import UserMgr from "../../UserMgr.js";
import {gridDisk} from "h3-js";

class EdgeMgr {

    hiddenEdges = [];
    visibleEdges = [];

    addHidden(index) {
        this.hiddenEdges.push(index);
    }

    async addVisible(index) {
        this.visibleEdges.push(index);

        await worldMgr.setHexFromRaw({
            index,
            type_id: constants.HEX_TYPE_UNKNOWN
        })

        locationMgr.selectorMgr.removeHex(index);
    }


    async add(index) {
        const isInInfluence = await locationMgr.inDiscoverRange(index);

        if (isInInfluence) {
            await this.addVisible(index);
        } else {
            this.addHidden(index);
        }
    }

    async mapUpdated() {

        // Фильтрация `toHidde` через for
        for (let i = this.visibleEdges.length - 1; i >= 0; i--) {
            const index = this.visibleEdges[i];
            const isInInfluence = await locationMgr.inDiscoverRange(index);
            if (!isInInfluence) {
                this.visibleEdges.splice(i, 1); // Удаляем элемент из visibleEdges

                const hexTypeId = worldMgr.getHexType(index);

                if (hexTypeId && hexTypeId == constants.HEX_TYPE_UNKNOWN) {
                    worldMgr.removeHex(index);
                    this.addHidden(index);
                }
            }
        }

        // Фильтрация `toShow` через for

        for (let i = this.hiddenEdges.length - 1; i >= 0; i--) {
            const index = this.hiddenEdges[i];
            const isInInfluence = await locationMgr.inDiscoverRange(index);
            if (isInInfluence) {

                const hexTypeId = worldMgr.getHexType(index);

                if (!hexTypeId || hexTypeId == constants.HEX_TYPE_UNKNOWN) {
                    await this.addVisible(index);
                }
                this.hiddenEdges.splice(i, 1);
            }
        }

    }
}

export default new EdgeMgr();
